var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"news"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"centered-top"},[_vm._v("NEWS")]),_c('input',{staticClass:"search__input",attrs:{"type":"text","placeholder":"SEARCH NEWS"}}),_c('NewsCards')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }